// Settings configured here will be merged into the final config object.
export default {
  apiUrl: 'http://localhost:3000',
};
